import { useServiceQuery } from '@generated/graphql'
import { marked } from 'marked'
import { useMemo } from 'react'
const TeikiView = () => {
  const { data } = useServiceQuery()
  const service = useMemo(() => {
    return data?.service?.data?.attributes
  }, [data])

  if (!service) {
    return null
  }
  return (
    <div className="container mx-auto">
      <div>
        <div className="p-4">
          <div className="my-4 font-bold" id="kiyaku">
            定期利用について
          </div>
          <div
            className="px-4"
            dangerouslySetInnerHTML={{
              __html: marked.parse(service?.aboutTeiki?.split('\n').join('<br />') || ''),
            }}
          ></div>
        </div>
      </div>
    </div>
  )
}

export { TeikiView }
